import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

const NEWSLETTER_URL = 'https://readdy.ai/api/form/d77uktbll6jbq2vdd13g';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch(NEWSLETTER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#4A5545] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row gap-12 md:gap-16">
          {/* Brand */}
          <div className="md:w-2/5">
            <img
              src="https://storage.readdy-site.link/project_files/1b4b5470-43ee-4e4c-a03f-80bf782ac886/295ea2cc-8770-43e6-ae89-4a5f4095a2e1_PAWZLY-7.png?v=947d967eac3d6db96af148317019d39e"
              alt="Pawzly Logo"
              className="h-28 w-auto object-contain mb-1"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              Making dog walks cleaner, easier, and more enjoyable — every single day.
            </p>

            <div className="mb-3">
              <p className="text-white font-semibold text-sm mb-1">Get 10% off your first order</p>
              <p className="text-white/50 text-xs mb-4">Join our newsletter for deals and dog tips.</p>
            </div>

            {submitted ? (
              <div className="flex items-center gap-2 text-[#A8C5A0] text-sm font-medium">
                <i className="ri-checkbox-circle-line text-lg"></i>
                You're in! Check your inbox.
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="flex gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="flex-1 bg-white/10 border border-white/20 text-white placeholder-white/40 text-sm px-4 py-2.5 rounded-full focus:outline-none focus:border-white/50 min-w-0"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-[#C4956A] hover:bg-[#b5845a] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
                >
                  {submitting ? '...' : 'Subscribe'}
                </button>
              </form>
            )}
          </div>

          {/* Links */}
          <div className="md:w-3/5 grid grid-cols-3 gap-8">
            <div>
              <p className="text-white font-semibold text-sm mb-4">Shop</p>
              <ul className="flex flex-col gap-2.5">
                {['Blue Breeze', 'Sunny Pop', 'Soft Sand', 'Ash Ease', 'All Products'].map((l) => (
                  <li key={l}>
                    <a href="#product" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-white font-semibold text-sm mb-4">Support</p>
              <ul className="flex flex-col gap-2.5">
                {['FAQ', 'Shipping Info', 'Returns', 'Contact Us', 'Track Order'].map((l) => (
                  <li key={l}>
                    <a href="#faq" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-white font-semibold text-sm mb-4">Company</p>
              <ul className="flex flex-col gap-2.5">
                <li><a href="#" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">About Us</a></li>
                <li><a href="#" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">Our Story</a></li>
                <li><Link to="/privacy" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">© 2026 Pawzly. All rights reserved.</p>
          <div className="flex items-center gap-4">
            {['ri-instagram-line', 'ri-tiktok-line', 'ri-facebook-circle-line', 'ri-twitter-x-line'].map((icon) => (
              <a key={icon} href="#" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-white transition-colors cursor-pointer">
                <i className={`${icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
